import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const getId = (store, key) => {
  let v = store.getItem(key);
  if (!v) { v = crypto.randomUUID(); store.setItem(key, v); }
  return v;
};

export const VisitTracker = () => {
  const location = useLocation();
  const current = useRef(null);

  useEffect(() => {
    const endVisit = () => {
      const c = current.current;
      if (!c) return;
      const seconds = (Date.now() - c.start) / 1000;
      try {
        navigator.sendBeacon(
          `${API_URL}/api/track/leave`,
          new Blob([JSON.stringify({ visit_id: c.visitId, seconds })], { type: 'application/json' })
        );
      } catch { /* noop */ }
      current.current = null;
    };
    endVisit();
    const start = Date.now();
    const token = localStorage.getItem('token');
    axios.post(`${API_URL}/api/track/page`, {
      path: location.pathname,
      session_id: getId(sessionStorage, 'tapn_session_id'),
      visitor_id: getId(localStorage, 'tapn_visitor_id'),
    }, token ? { headers: { Authorization: `Bearer ${token}` } } : {})
      .then((r) => { current.current = { visitId: r.data.visit_id, start }; })
      .catch(() => {});
    window.addEventListener('pagehide', endVisit);
    return () => { window.removeEventListener('pagehide', endVisit); endVisit(); };
  }, [location.pathname]);

  return null;
};
